module.exports = __webpack_public_path__ + "assets/img/related-image-01.1c017da9.jpg";